<template lang="pug">
  v-card.mt-5.full-width(width="100")
    Header(
      icon="store",
      :to="{ name: 'shops' }",
    )
    FormWrapper(type="shop")
      template( v-slot:default="props")
        ShopForm(
          :model="props.model",
          :validate="props.validate",
          :valid="props.valid",
        )
</template>

<script>
import FormWrapper from '@/components/wrapper/FormWrapper.vue';
import Header from '@/components/forms/Header.vue';
import ShopForm from '@/components/forms/Shop.vue';

export default {
  components: {
    FormWrapper,
    Header,
    ShopForm,
  },
};
</script>
